import css from './faqArticleSearch.module.css'
import useFaqArticleSearch from './useFaqArticleSearch'
import { ITreePluginsProps } from '../../../../../shared/Tree/tree.types'
import SearchInput from '../../../../../shared/Inputs/SearchInput'
import CircleLoader from '../../../../../shared/Loaders/CircleLoader'
import cn from '../../../../../utils/cn'
import { FocusEvent, useEffect, useState } from 'react'
import Popover from 'shared/Modal/Popover'
import { useRecoilValue } from 'recoil'
import faqSelectors from '../../faq.selectors'

type IProps = ITreePluginsProps

const FaqArticleSearch = (props: IProps) => {
  const { loading, search, articles, selectedArticleId, setSelectedArticleId, setSearch } = useFaqArticleSearch()

  const [searchAnchorEl, setSearchnchorEl] = useState<HTMLInputElement | null>(null)

  const faqCategoriesMap = useRecoilValue(faqSelectors.faqCategoriesMap)

  useEffect(() => {})

  const handleFocusSearch = (e: FocusEvent<HTMLInputElement>) => {
    setSearchnchorEl(e.currentTarget)
  }

  const handleCloseSearch = () => {
    setSearchnchorEl(null)
  }

  return (
    <div>
      <div className={css.searchContainer}>
        <SearchInput
          value={search}
          name='search'
          onChange={setSearch}
          required={false}
          placeholder='Поиск'
          onFocus={handleFocusSearch}
        />
        {loading && (
          <div className={css.loaderContainer}>
            <CircleLoader />
          </div>
        )}
      </div>
      <Popover
        open={!!searchAnchorEl && !!articles.length}
        onClose={handleCloseSearch}
        anchorEl={searchAnchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      >
        <div className={css.articles}>
          {articles.map((article) => {
            const isArticleSelected =
              selectedArticleId === article.id && props.leafSelectCtrl.selectedItem === article.id
            return (
              <div
                className={cn(css.article, isArticleSelected && css.selectedArticle)}
                onClick={() => {
                  setSelectedArticleId(article.id)
                  props.expandCtrl.setExpanded(new Set([article.categoryId]))
                  props.leafSelectCtrl.handleSelect(article.id)
                }}
              >
                <p className='text--body-m line-clamp' key={article.id} title={article.title}>
                  {article.title}
                </p>
                <p className='text--body-xxs text--secondary'>{faqCategoriesMap[article.categoryId]?.title}</p>
              </div>
            )
          })}
        </div>
      </Popover>
    </div>
  )
}

export default FaqArticleSearch
